import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';
import aboutImage from '../../assets/cosmin_about.jpeg';

const About = () => {
    return (
        <div className="about-page">

            <header className="about-hero">
                <div className="container">
                    <h1>Antrenorul <span className="text-highlight">Tău</span>.</h1>
                    <p className="hero-subtitle">Dedicat să te ghidez spre cea mai bună versiune a ta.</p>
                </div>
            </header>

            <section className="about-content-section">
                <div className="container split-layout">

                    {/* Coloana Stângă: Imaginea */}
                    <div className="image-column">
                        <div className="image-wrapper-styled">
                            <div className="neon-backdrop"></div>
                            <img src={aboutImage} alt="Cosmin Hadade" className="about-img" />
                        </div>
                    </div>

                    {/* Coloana Dreaptă: Textul lui Cosmin */}
                    <div className="text-column">
                        <h2 className="section-title">Salut, sunt Cosmin Hadade.</h2>
                        <h3 className="about-subtitle">Antrenor Fitness, Online Coach & Creatorul FitSimplu</h3>

                        <div className="story-content">
                            <p>
                                Fitnessul face parte din viața mea încă din adolescență. Am început să merg la sală la vârsta de 15–16 ani, iar de atunci sportul a devenit mai mult decât un hobby — a devenit un mod de viață.
                            </p>

                            <p>
                                Cu peste <strong>16 ani de experiență</strong> în antrenamente, 10 ani ca antrenor și experiență directă ca sportiv de competiție, am ajutat sute de persoane să slăbească, să-și definească corpul și să adopte un stil de viață sănătos. Din dorința de a face lucrurile mai simple și mai eficiente, am creat <strong>programul FitSimplu</strong> — o metodă bazată pe antrenamente inteligente, nutriție echilibrată și disciplină, fără diete extreme sau programe complicate.
                            </p>

                            <p>
                                Am participat la competiții de culturism și fitness, obținând rezultate notabile, printre care:
                                <br />
                                🏆 <strong>Locul 2</strong> – Cupa României Men’s Physique
                                <br />
                                🥉 <strong>Locul 3</strong> – Campionatul Național Men’s Fit Model
                            </p>

                            <p>
                                Experiența acumulată atât în competiții, cât și în lucrul direct cu clienții, m-a învățat că orice transformare reală începe cu mentalitatea potrivită. Un corp puternic se construiește în timp, iar consecvența și disciplina fac diferența pe termen lung.
                            </p>
                        </div>

                        <div className="signature-block">
                            <p>Dacă îți dorești o schimbare reală și ești pregătit să muncești pentru obiectivele tale, totul începe cu primul pas — hai să-l facem împreună.</p>
                            <span className="signature">Cosmin H.</span>
                        </div>

                        <div className="cta-block">
                            <Link to="/plans" className="btn-neon">Începe Transformarea</Link>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
};

export default About;